exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chioseGoods[data-v-df3cbea2]{border:1px solid #e8e8e8;margin-bottom:10px;padding:10px 10px}.chioseGoodsList[data-v-df3cbea2]{display:inline-block;margin-left:15px;margin-top:10px}", ""]);

// exports
